import styled from '@emotion/styled';

import AnimatedBox from './animated_box';

const CardsFadeIn = styled(AnimatedBox)`
  display: grid;

  grid-template-columns: repeat(${props => (props.columns === 2 ? 2 : 3)}, 1fr);

  ${props =>
    props.size && props.size === 'small'
      ? `
    grid-column-gap: 5%;
  `
      : `
    grid-column-gap: 10%;
  `}

  align-items: start;
  justify-content: center;
  justify-items: center;

  height: 100%;
  width: 100%;

  .wrapper:nth-of-type(1) {
    grid-column: ${props => (props.columns === 2 ? '1' : '2')};
    grid-row: 1;
  }

  .wrapper:nth-of-type(2) {
    grid-column: ${props => (props.columns === 2 ? '2' : '3')};
    grid-row: 1;
  }

  .wrapper:nth-of-type(3) {
    grid-column: 1;
    grid-row: 1;
  }
`;

export default CardsFadeIn;
